<template>
  <Primitive
    :as="as"
    :class="
      cn(
        variants({ variant, size, mode, placeholder: !imageUrl, alpha }),
        props.class
      )
    "
  >
    <img v-if="imageUrl" :src="imageUrl" class="w-full h-full object-cover" />
    <Icon v-else :name="iconName" variant="fill" size="full" />
  </Primitive>
</template>

<script setup>
import { computed } from "vue";
import { Primitive } from "radix-vue";
import { cn } from "@/Utils/cn";
import { sizes, variants } from ".";
import { Icon } from "@/SharedComponents/Icon";

const props = defineProps({
  variant: {
    type: String,
    default: "building",
  },
  isGroup: {
    type: Boolean,
    default: false,
  },
  alpha: {
    type: Boolean,
    default: false,
  },
  size: {
    type: null,
    validator: (val) => sizes.includes(val),
    required: false,
    default: "md",
  },
  as: {
    type: String,
    default: "div",
  },
  mode: {
    type: String,
    default: "transparent",
  },
  imageUrl: {
    type: String,
    default: null,
  },
  class: {
    type: String,
    required: false,
  },
});

const iconName = computed(() => {
  if (
    props.isGroup &&
    props.variant !== "building" &&
    props.variant !== "space"
  ) {
    return "folder-open";
  }

  if (props.isGroup && props.variant === "building") {
    return "building-group";
  }

  switch (props.variant) {
    case "tasks":
      return "board-tasks";
    case "recurring-tasks":
      return "repeat";
    case "building":
      return "building-happy";
    case "layout":
      return "sitemap";
    case "info":
      return "info-circle";
    case "users":
      return "users-default";
    case "roles":
      return "shield-check";
    case "flow":
      return "chat-happy";
    case "files":
      return "documents";
    case "passports":
      return "cards";
    case "qr-code":
      return "qr-code";
    case "space":
      return "location-marker";
    case "asset":
      return "asset";
    case "asset_group":
    case "folder":
      return "folder-open";
    case "category":
      return "hashtag-square";
    case "tag":
      return "tag";
    case "information":
      return "passport";
    case "checklist_item":
      return "checklist";
  }

  return "placeholder";
});
</script>
